<template>
    <div :class="{'filter_pop': true,'w0': !isShow}">
        <div class="fp_bg" v-if="isShow&& direction != 'fade'" @click="handleClose"></div>
        <transition
            :enter-active-class="'animate__animated ' + (direction != 'up' ? (direction != 'fade'? 'animate__slideInRight': 'animate__fadeIn') : 'animate__slideInUp')"
            :leave-active-class="'animate__animated ' + (direction != 'up' ? (direction != 'fade' ? 'animate__slideOutRight' : 'animate__fadeOut') : 'animate__slideOutDown')">
            <div :class="{'fq_content':true,'up_content': direction == 'up' || direction == 'fade','noborder-radius': type == 'agree' || type == 'agree2'}" v-if="isShow">
                <Props v-if="type == 'props'" @handleClose="handleClose" />
                <Game v-else-if="type == 'game'" :notUserRoleList="notUserRoleList"/>
                <Game2 v-else-if="type == 'game2'" />
                <Props2 v-else-if="type == 'props2'" @handleClose="handleClose" />
                <JhLogin v-else-if="type == 'jhlogin'" :selection="selection" @handleSuccess="handleSuccess" />
                <Role v-else-if="type == 'role'" :selection="selection" @handleSuccess="handleSuccess"/>
                <Server v-else-if="type == 'server'" @handleClose="handleClose"/>
                <Login v-else-if="type == 'login'"
                @handleSuccess="handleSuccess" @handleClose="handleClose"/>
                <RoleServer v-else-if="type == 'roleserver'" :selection="selection" @handleSuccess="handleSuccess" @handleFunc="handleFunc"/>
                <Agree v-else-if="type == 'agree'" @handleClose="handleClose" @handleSuccess="handleSuccess"/>
                <Agree2 v-else-if="type == 'agree2'" @handleClose="handleClose" @handleSuccess="handleSuccess"/>
                <SellType v-else-if="type == 'selltype'" 
                @handleClose="handleClose" @handleSuccess="handleSuccess" :selection="selection"/>
                <MixPay v-else-if="type == 'mixpay'" :selection="selection" @handleClose="handleClose" @handleSuccess="handleSuccess"/>
                <PassWord v-else-if="type == 'password'" :selection="selection" @handleClose="handleClose" @handleSuccess="handleSuccess" @handleFunc="handleFunc"/>
                <Role2 v-else-if="type == 'role2'" :selection="selection" @handleSuccess="handleSuccess"/>
                <QuickRegister v-else-if="type == 'quickregister'" :selection="selection" @handleClose="handleClose" @handleSuccess="handleSuccess"/>
                <AlipayAccounts v-else-if="type == 'alipayaccounts'" :selection="selection" @handleClose="handleClose" @handleSuccess="handleSuccess"/>
                <Game3 v-else-if="type == 'game3'" @handleSuccess="handleSuccess"/>
                <Role3 v-else-if="type == 'role3'" :selection="selection" @handleSuccess="handleSuccess"/>
            </div>
        </transition>
    </div>
</template>
<script>
    import Props from './components/Props'
    import Game from './components/Game'
    import Game2 from './components/Game2'
    import Props2 from './components/Props2'
    import JhLogin from './components/JhLogin'
    import Role from './components/Role'
    import Server from './components/Server'
    import Login from './components/Login'
    import RoleServer from './components/RoleServer'
    import Agree from './components/Agree'
    import Agree2 from './components/Agree2'
    import SellType from './components/SellType'
    import MixPay from './components/MixPay'
    import PassWord from './components/PassWord'
    import Role2 from './components/Role2'
    import QuickRegister from './components/QuickRegister'
    import AlipayAccounts from './components/AlipayAccounts'
    import Game3 from './components/Game3'
    import Role3 from './components/Role3'
    export default {
        props: {
            onSuccess: Function,
            onError: Function,
            onClose: Function,
            type: String,
            direction: String,
            notUserRoleList: {
                type: Boolean,
                default: false
            },
            selection: [Array,Object],
            onFunc: Function
        },
        components: {
            Props,
            Game,
            Game2,
            Props2,
            JhLogin,
            Role,
            Server,
            Login,
            RoleServer,
            Agree,
            Agree2,
            SellType,
            MixPay,
            PassWord,
            Role2,
            QuickRegister,
            AlipayAccounts,
            Game3,
            Role3
        },
        data() {
            return {
                isShow: false
            }
        },
        methods: {
            handleClose() {
                this.isShow = false
                if (this.onClose) this.onClose()
                document.querySelector('body').style.overflow = 'unset'
            },
            handleSuccess(data) {
                this.isShow = false
                if (this.onSuccess) this.onSuccess(data)
                document.querySelector('body').style.overflow = 'unset'
            },
            handleFunc(data) {
                if (this.onFunc) this.onFunc(data)
            }
        },
        watch: {
            '$route.name': {
                immediate: true,
                handler() {
                    this.isShow = false
                    document.querySelector('body').style.overflow = 'unset'
                },
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../assets/animate.css';

    .filter_pop {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        height: 100%;
        z-index: 10000;
        overflow: hidden;
        display: block;

        .fp_bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 10000;
        }

        .fq_content {
            position: absolute;
            right: 0;
            top: 0;
            width: 32rem;
            height: 100%;
            background-color: #fff;
            z-index: 10001;
            border-top-left-radius: 1rem;
            border-bottom-left-radius: 1rem;
            &.up_content {
                width: 100%;
                max-width: 525px;
                height: auto;
                top: unset;
                bottom: 0;
                border-bottom-left-radius: 0;
                border-top-right-radius: 1rem;
                overflow: hidden;
            }
            &.noborder-radius {
                border-radius: 0;
            }
        }
    }
</style>
